var _defs, _circle, _path, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFindCustomers(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 53.91 52",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #c5dbfd;\n      }\n\n      .cls-2 {\n        fill: #f2f7fe;\n      }\n\n      .cls-3 {\n        fill: #2578f6;\n      }\n    "))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 26.95,
    cy: 26,
    r: 23.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M26.95,49.5c-12.96,0-23.5-10.54-23.5-23.5S13.99,2.5,26.95,2.5s23.5,10.54,23.5,23.5-10.54,23.5-23.5,23.5ZM26.95,4C14.82,4,4.95,13.87,4.95,26s9.87,22,22,22,22-9.87,22-22S39.08,4,26.95,4Z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_556"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_408",
    className: "cls-3",
    d: "M36.92,19.76c0,2.2-1.79,3.99-3.99,3.99-2.2,0-3.99-1.79-3.99-3.99,0-2.2,1.78-3.99,3.99-3.99,2.2,0,3.99,1.78,3.99,3.99h0M35.3,24.63h-4.74c-1.74,0-3.32,1-4.06,2.58,2.29.42,4.15,2.07,4.85,4.29h7.11c.74,0,1.35-.6,1.35-1.35,0,0,0,0,0,0v-1.03c0-2.48-2.02-4.49-4.5-4.49ZM22.49,17.01c-2.69,0-4.87,2.18-4.87,4.87s2.18,4.87,4.87,4.87,4.87-2.18,4.87-4.87c0-2.69-2.18-4.87-4.87-4.87M30.88,34.58v-1.25c0-3.03-2.46-5.49-5.49-5.49h-5.8c-3.03,0-5.49,2.46-5.49,5.49v1.25c0,.91.74,1.65,1.65,1.65h13.49c.91,0,1.64-.74,1.64-1.65Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFindCustomers);
export default __webpack_public_path__ + "static/media/Find Customers.e9b8f330e0afd7dcd4f92de4a7e56082.svg";
export { ForwardRef as ReactComponent };